import { canUseDOM } from 'exenv';
import parse from 'url-parse';

export default function getQueryParameterByName(queryName) {
  if (canUseDOM) {
    let name = queryName;
    // eslint-disable-next-line no-useless-escape
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(window.location.href);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  return null;
}

export function correctSubDomain(url) {
  if (url && url.indexOf('https://www.') === -1 && typeof url === 'string') {
    return url.replace('https://', 'https://www.');
  }

  return url;
}

export function resolveHost(url) {
  if (!url) {
    // todo: log error
    return '';
  }

  if (/\/wp.fastcompany.com\/fastcodesign/.test(url)) {
    return 'fastcodesign.com';
  }

  if (/\/wp.fastcompany.com\/fastcocreate/.test(url)) {
    return 'fastcocreate.com';
  }

  if (/\/wp.fastcompany.com\/fastcoexist/.test(url)) {
    return 'fastcoexist.com';
  }

  const { host } = parse(url, true);

  if (host === 'wp.fastcompany.com') {
    return 'fastcompany.com';
  }

  return host;
}



// WEBPACK FOOTER //
// ./src/utils/url_util.js